jQuery( document ).ready( function () {  
  jQuery( '.menu__item--has-submenu' ).unbind( 'click' );

  jQuery( window ).on( 'scroll', function ( evt ) {
    jQuery( '.shipping-details-dropdown, .show-shipping-details-dropdown' ).removeClass( 'open' );
  });

  jQuery( '.show-shipping-details-dropdown' ).on( 'click tap', function ( evt ) {
    evt.preventDefault();
    evt.stopPropagation();

    jQuery( '.shipping-details-dropdown, .show-shipping-details-dropdown' ).toggleClass( 'open' );
  } );

  if ( jQuery( 'body.template-index, body#anfibio-quality-charter' ).length > 0 ) {
    jQuery( window ).on( 'scroll', function ( evt ) {
      if ( $(this).scrollTop() > 0 ) {
        jQuery( '#header' ).addClass( 'header--active-new' );
      } else {
        jQuery( '#header' ).removeClass( 'header--active-new' );
      }
    });

    if ( $( window ).scrollTop() > 0 ) {
      jQuery( '#header' ).addClass( 'header--active-new' );
    }
  } else {
    jQuery( '#header' ).addClass( 'header--active-new' );
  }
  
  jQuery( '.header__menu .menu__item--has-submenu > a' ).on( 'click', function ( evt ) {
    evt.preventDefault();
    var $submenu = jQuery( this ).siblings( '.menu__submenu-new' );

    jQuery( this ).parent().siblings( '.menu__item--has-submenu' ).find( '.menu__submenu-new.open' ).removeClass( 'open' );

    $submenu.toggleClass( 'open' );

    if ( $submenu.hasClass( 'open' ) ) {
      jQuery( this ).parents( '#header' ).addClass( 'open-submenu' )
    } else {
      jQuery( this ).parents( '#header' ).removeClass( 'open-submenu' )
    }
  });

  jQuery( '.menu__submenu-new' ).on( 'click', function ( evt ) {
    if ( !jQuery( evt.target ).hasClass( 'submenu__wrapper' ) && jQuery( evt.target ).parents( '.submenu__wrapper' ).length < 1 ) {
      jQuery( this ).removeClass( 'open' );
      jQuery( '#header' ).removeClass( 'open-submenu' );
    }
  });
  jQuery( '.menu__submenu-new .submenu-item' ).hover(function () {
    jQuery( this ).parents( '.menu__submenu-new' ).find( '.submenu__right' ).css( "background-image", "url(" + jQuery( this ).data("menu-image") + ")");
  });
  
  jQuery( document ).on( 'click', 'body', function ( evt ) {
    if ( jQuery( evt.target ).hasClass( 'quicklinks__item' ) ) {
      jQuery( evt.target ).toggleClass( 'open' );
    } else if ( jQuery( evt.target ).parents( '.quicklinks__item' ).length > 0 ) {
      jQuery( evt.target ).parents( '.quicklinks__item' ).toggleClass( 'open' );
    } else {
      jQuery( '.header__quicklinks .quicklinks__item.open' ).each( function () {
        jQuery( this ).removeClass( 'open' );
      });
    }
  });

  jQuery( '.header__quicklinks' ).on( 'click', '.ly-currency-switcher-link', function ( evt ) {
      evt.preventDefault();
      
      var $form  = jQuery( this ).parents( '.quicklinks__item' ).find( 'form' );
      $form.find( '#currency-field' ).val( jQuery( this ).data( 'currencycode' ) );
      $form.submit();
  });
  
    //jQuery( document ).off( 'click', '.menu__item--has-submenu' );
    /*jQuery( '.menu__item--has-submenu' ).unbind( 'click' );

    jQuery( document ).on( 'mouseenter', '.menu__item--has-submenu', function ( evt ) {
        evt.preventDefault();

        jQuery( '.menu__item--has-submenu' ).removeClass( 'menu__item--opened' );
        jQuery( this ).parents( '#header' ).addClass( 'header--active' );
        jQuery( this ).addClass( 'menu__item--opened' );
        jQuery( 'body' ).addClass( 'menu-item-overlay-active' );
    } );

    jQuery( document ).on( 'mouseleave', 'header#header', function ( evt ) {
        evt.preventDefault();

        if ( jQuery( 'body.template-index' ).length > 0 && jQuery( window ).scrollTop() == 0 ) {
            jQuery( this ).removeClass( 'header--active' );
        }

        jQuery( '.menu__item--has-submenu' ).removeClass( 'menu__item--opened' );
        jQuery( 'body' ).removeClass( 'menu-item-overlay-active' );
    } );*/

    jQuery( document ).on( 'click', '.mobile-menu__item--has-submenu:not(.menu__item--opened) > a', function ( evt ) {
        evt.preventDefault();
    });
    jQuery( document ).on( 'pointerup tap', '.mobile-menu__item--has-submenu:not(.menu__item--opened) > a', function ( evt ) {
        evt.preventDefault();

        jQuery( this ).parent().addClass( 'menu__item--opened' );
    } );

    jQuery( document ).on( 'click', '.mobile-menu__item--has-submenu.menu__item--opened > a', function ( evt ) {
        evt.preventDefault();
    });
    jQuery( document ).on( 'pointerup tap', '.mobile-menu__item--has-submenu.menu__item--opened > a', function ( evt ) {
        evt.preventDefault();

        jQuery( this ).parent().removeClass( 'menu__item--opened' );
    } );



    // you wouldn't need this unless you need to account for some fixed offset
    var pad = ( $( '#header' ).height() * 2 );
    scrollTo();

    jQuery( 'body' ).on( 'click', '.cover-more-arrow', function ( event ) {
        event.preventDefault();
        $( 'html, body' ).stop().animate( {
            scrollTop: ( jQuery( '#shopify-section-home-collection' ).offset().top - ( jQuery( "#header" ).height() ) )
        }, 1000 );
    } );

    if ( window.location.hash && $( 'body' ).attr( 'id' ) === 'customer-care' || window.location.hash && $( 'body' ).attr( 'id' ) === 'service-a-la-clientele' ) {
        openFaqSection( window.location.hash );
    }
    
    jQuery( document ).on( 'click', '#face3-language-switcher-dropdown > ul > li > a', function ( evt ) {
        evt.preventDefault();
    });
  
    jQuery( document ).on( 'pointerup', '#face3-language-switcher-dropdown > ul > li > a', function ( evt ) {
        evt.preventDefault();
        
        jQuery( this ).parent( 'li' ).toggleClass( 'open' );
    });
    
    jQuery( document ).on( 'click', '#face3-language-switcher-dropdown', function ( evt ) {
        evt.stopPropagation();
    });
    
    /*jQuery( document ).on( 'click', 'body', function ( evt ) {
        jQuery( '.header__quicklinks .quicklinks__item.open, .shopify-currency-form li.open' ).each( function () {
          if ( jQuery( this ) != jQuery( evt.target ).parent() ) {
            console.log('NOT')
            jQuery( this ).removeClass( 'open' );
          }

          console.log( jQuery( this ) );
          console.log( jQuery( evt.target ).parent() );
        });
    });*/
    
    jQuery( document ).on( 'click', '.shopify-currency-form > ul > li > a', function ( evt ) {
        evt.preventDefault();
    });
    jQuery( document ).on( 'pointerup', '.shopify-currency-form > ul > li > a', function ( evt ) {
        evt.preventDefault();
        
        jQuery( this ).parent( 'li' ).toggleClass( 'open' );
    });
    jQuery( document ).on( 'pointerup', '.shopify-currency-form > ul > li > ul > li > a', function ( evt ) {
        evt.preventDefault();
        
        var $form  = jQuery( this ).parents( 'form' );
        $form.find( '#currency-field' ).val( jQuery( this ).data( 'currencycode' ) );
        $form.submit();
    });
    
    jQuery( document ).on( 'click', '.mobile-menu__item .shopify-currency-form a', function ( evt ) {
        evt.preventDefault();
    });
    jQuery( document ).on( 'pointerup', '.mobile-menu__item .shopify-currency-form a', function ( evt ) {
        evt.preventDefault();
        
        var $form  = jQuery( this ).parents( 'form' );
        $form.find( '#currency-field-inline' ).val( jQuery( this ).data( 'currencycode' ) );
        $form.submit();
    });
    
    jQuery( document ).on( 'click', '.shopify-currency-form', function ( evt ) {
        evt.stopPropagation();
    });
  
    jQuery( document ).on( 'mouseenter click', '.card__colorSwatch span', function( evt ) {
        if ( evt.type == 'click' && Modernizr.touch ) {
			evt.preventDefault();
        }
    	var $productCard = jQuery( this ).parents( '.product-card' );
      	var variantLink = jQuery( this ).parent().attr( 'href' );
        var variantImage = jQuery( this ).data( 'image' );
        var variantImageSrcSet = jQuery( this ).data( 'srcset' );
      
      	$productCard.find( '.card__title > a' ).attr( 'href', variantLink );
      	$productCard.find( '.card__image' ).attr( 'href', variantLink );
      	
      	if ( variantImage !== undefined ) {
			$productCard.find( 'img.main' ).attr( 'src', variantImage ).attr( 'srcset', variantImageSrcSet );
        }
    });
  
    jQuery( document ).on( 'click', '#newsletter-popup-close', function ( evt ) {
        jQuery( '#newsletter-popup' ).removeClass( 'show' );
        document.cookie = "newsletter_popup_seen=yes;";
    });
        
    jQuery( document ).on( 'click', '.image-link .video-link', function ( evt ) {
      evt.preventDefault();

      var videoWidth = 720,
          videoHeight = 720,
          windowWidth = jQuery( window ).width();

      if ( windowWidth < 720 ) {
        videoWidth = windowWidth - 60;
        videoHeight = videoWidth;
      }
      
      var embedVideoSrc = jQuery( this ).data( 'embedvideo' );

      $.colorbox({
        maxHeight: videoHeight + 'px',
        maxWidth: videoWidth + 'px',
        html: '<div class="popup-video-wrapper"><video id="video" class="desktop" src="' + embedVideoSrc + '" playsinline controls autoplay preload muted loop preload="metadata" crossorigin="anonymous"></div>',
        closeButton : true,
        close: '&times;',
        scrolling: false,
        onComplete: function () {
          //jQuery( '.popup-video-wrapper' ).append( '' );
        }
      });
    });
    
  	jQuery( document ).on( 'click', '#btn-clear-filters', function ( evt ) {
      	evt.preventDefault();
      
      	jQuery( '.filters__groupContent input:checked' ).prop( 'checked', false );
    });

    jQuery( '.search-form #search-clear' ).on( 'click', function ( evt ) {
      evt.preventDefault();
  
      jQuery( '.search-form .form__control' ).val( '' );
    });

    jQuery( '[data-trigger=open_search]' ).on( 'click', function ( evt ) {
      evt.preventDefault();

      jQuery( '#search' ).addClass( 'blurred' );
    });

    jQuery( '[data-trigger=close_search]' ).on( 'click', function ( evt ) {
      evt.preventDefault();

      setTimeout(() => {
        jQuery( '#search' ).removeClass( 'blurred' );
      }, 500);
    });

    jQuery( '#search' ).on( 'click', function ( evt ) {
      if ( !jQuery( evt.target ).hasClass( 'search-container' ) && jQuery( evt.target ).parents( '.search-container' ).length < 1 ) {
        jQuery( this ).removeClass( 'search--is-active' );
        setTimeout(() => {
        jQuery( '#search' ).removeClass( 'blurred' );
      }, 500);
      }
    });

    jQuery( 'body' ).on( 'click', '[data-trigger=open_book_appointment]', function ( evt ) {
      evt.preventDefault();

      jQuery( '.form__control--location' ).val( jQuery( this ).data( 'location' ) ).change();
      jQuery( '#book-appointment' ).addClass( 'book-appointment--is-active' ).addClass( 'blurred' );
    });

    jQuery( '[data-trigger=close_book_appointment]' ).on( 'click', function ( evt ) {
      evt.preventDefault();
      jQuery( '#book-appointment' ).removeClass('book-appointment--is-active' );
      
      setTimeout(() => {
        jQuery( '#book-appointment' ).removeClass( 'blurred' );
      }, 500);
    });

    jQuery( '#book-appointment' ).on( 'click', function ( evt ) {
      if ( !jQuery( evt.target ).hasClass( 'book-appointment-container' ) && jQuery( evt.target ).parents( '.book-appointment-container' ).length < 1 ) {
        jQuery( this ).removeClass( 'book-appointment--is-active' );
        
        setTimeout(() => {
        jQuery( '#book-appointment' ).removeClass( 'blurred' );
      }, 500);
      }
    });
  
  	jQuery( document ).on( 'click', '#btn-apply-filters', function ( evt ) {
      	evt.preventDefault();
      
      	var newFilterLink = jQuery('#base_url').val();
      	var newFilters = '';
      
        jQuery( '.filters__groupContent input:checked' ).each( function () {
			newFilters += jQuery(this).val() + '+';
        });
      
      	newFilters = newFilters.replace(/\+$/,'');
      
      	window.location = newFilterLink + '/' + newFilters;
    });
  
    jQuery( document ).on( 'click', '.filters__groupHeading', function ( evt ) {
		jQuery( this ).parent( '.filters__groupSection' ).toggleClass( 'open' );
    });

    $(".barclose").click(function(){
        $("body").addClass("topbar-close");
    });

    $( '.stories-menu' ).on( 'click', function ( evt ) {
      evt.preventDefault();
      autoScrollAnchors( $( this ).attr( 'href' ) );
    });

    $( '.tab-toggle' ).on( 'click', function ( evt ) {
      evt.preventDefault();

      showCustomerCareTab( $( this ).attr( 'href' ) );
    });

  $( '.customer-care-menu select' ).on( 'change', function ( evt ) {
    evt.preventDefault();
    if ( jQuery( this ).val().startsWith( '#' ) ) {
      showCustomerCareTab( jQuery( this ).val() );
    } else {
      window.location = jQuery( this ).val();
    }
  });

  $( '.footer-tab-toggle' ).on( 'click', function ( evt ) {
    if ( $( '.customer-care-tabs' ).length ) {
      evt.preventDefault();

      jQuery( '#header' ).removeClass( 'open-submenu' );
      jQuery( '.menu__submenu-new' ).removeClass( 'open' );
      
      var tabId = $( this ).attr( 'href' ).substr( $( this ).attr( 'href' ).indexOf('#') );
  
      showCustomerCareTab( tabId );
    }
  });

  $( '.content-container > .btn-read-more' ).on( 'click', function ( evt ) {
    evt.preventDefault();

    $( this ).parent().addClass( 'open' );
    $( this ).hide();
  })

  $( '#footer .footer-middle .footer-content .footer-menu-column h2' ).on( 'click', function ( evt ) {
    $( this ).parent().toggleClass( 'open' );
  });

  if ( $( '.customer-care-tabs' ).length ) {
    var hash = window.location.hash;
    if ( hash ) {
      showCustomerCareTab( hash );
    }
  }
  
    checkNewsletterPopupCookie();
} );

function showCustomerCareTab ( tabId ) {
  if ( $( '.customer-care-tabs > ' + tabId ).length ) {
    $( '.tab' ).removeClass( 'active' );
    $( tabId ).addClass( 'active' );
  
    if ( tabId == '#customer-care-info' ) {
      $( '.contact-info' ).hide();
    } else {
      $( '.contact-info' ).show();
    }

    var pad = $( '#header' ).height() * 2;

    $( 'html, body' ).animate( { scrollTop: $( '.customer-care-tabs' ).offset().top - pad }, 300 );
  }
}

function checkNewsletterPopupCookie () {
    if ( document.cookie.indexOf( 'newsletter_popup_seen' ) < 0 ) {

      if ( jQuery( '#newsletter-popup' ).find( '.newsletter-success' ).length ) {
        jQuery( '#newsletter-popup' ).addClass( 'show' );
      } else {
      //display popup with delay
        setTimeout( function() {
          jQuery( '#newsletter-popup' ).addClass( 'show' );
        }, 5000 );
      }
    }
}

function openFaqSection ( hash, scroll ) {
    if ( $( hash ).hasClass( 'tabs__item' ) ) {
      $( hash ).addClass( 'tabs__item--active' );
    } else if ( $( hash ).hasClass( 'tabs' ) ) {
      $( hash ).find( '.tabs__item:first-of-type' ).addClass( 'tabs__item--active' );
    }

    if ( scroll != undefined && scroll == true ) {
      autoScrollAnchors( hash );
    }
}

function isScrolledAboveView ( $elem ) {
    var docViewTop = jQuery( window ).scrollTop();

    var elemTop = jQuery( $elem ).offset().top;

    //97 to compensate for header height
    return ( elemTop - 97 ) <= docViewTop;
}

function isScrolledAboveThreeQuartersView ( $elem ) {
    var docViewTop = jQuery( window ).scrollTop();
    var windowHeight = jQuery( window ).height();

    var elemTop = jQuery( $elem ).offset().top;

    return elemTop <= ( docViewTop + ( windowHeight / 3 ) );
}

function isScrolledAboveScreenBottom ( $elem ) {
    var docViewTop = jQuery( window ).scrollTop();
    var windowHeight = jQuery( window ).height();

    var elemTop = jQuery( $elem ).offset().top;

    return elemTop <= (docViewTop + windowHeight);
}

function scrollTo () {
    var links = document.getElementsByTagName( 'a' );
    for ( var i = 0; i < links.length; i++ ) {
        var link = links[i];
      
        if (( $( 'body' ).attr( 'id' ) == 'customer-care' || $( 'body' ).attr( 'id' ) == 'service-a-la-clientele' ) && ( link.href.indexOf( '#anfibio-tab-' ) !== -1 ) ) {
            var newLink = link.href.replace( window.location.origin + window.location.pathname, '' );
            link.href = newLink;
            link.onclick = function ( e, respond ) { scrollAnchors( e, respond ); openFaqSection( e.target.getAttribute( 'href' ) ); };
        } else if ( ( link.href && ( link.href.indexOf( '#' ) == 0 ) && ( link.href.indexOf( '#' ) != link.href.length - 1 ) && ( link.pathname == location.pathname ) || ( '/' + link.pathname == location.pathname ) ) && ( link.search == location.search ) ) {
            link.onclick = scrollAnchors;
        }
    }

    if ( window.location.hash ) {

        autoScrollAnchors( $( window.location.hash ) );

    }
}

function scrollAnchors ( e, respond ) {

    const distanceToTop = function ( el ) { return Math.floor( el.getBoundingClientRect().top ); };//el => Math.floor( el.getBoundingClientRect().top );
    e.preventDefault();

    var targetID = ( respond ) ? respond.getAttribute( 'href' ) : e.currentTarget.getAttribute( 'href' );
  
    targetID = '#' + targetID.split("#")[1];
    const targetAnchor = document.querySelector( targetID );
    if ( !targetAnchor )
        return;
    const originalTop = distanceToTop( targetAnchor );
    window.scrollBy( { top: originalTop - 170, left: 0, behavior: 'smooth' } );
    const checkIfDone = setInterval( function () {
        const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;
        if ( distanceToTop( targetAnchor ) === 0 || atBottom ) {
            targetAnchor.tabIndex = '-1';
            targetAnchor.focus();
            window.history.pushState( '', '', targetID );
            clearInterval( checkIfDone );
        }
    }, 100 );
}
function autoScrollAnchors ( e, respond ) {
    var pad = $( '#header' ).height() * 2;
    $( 'html, body' ).animate( { scrollTop: $( e ).offset().top - pad }, 300 );
}

// Swipe Up / Down / Left / Right
var initialX = null;
var initialY = null;

function startTouch ( e ) {
    initialX = e.touches[0].clientX;
    initialY = e.touches[0].clientY;
}

function moveTouch ( e ) {
    if ( initialX === null ) {
        return;
    }

    if ( initialY === null ) {
        return;
    }

    var currentX = e.touches[0].clientX;
    var currentY = e.touches[0].clientY;

    var diffX = initialX - currentX;
    var diffY = initialY - currentY;

    if ( Math.abs( diffX ) > Math.abs( diffY ) ) {
        // sliding horizontally
        if ( diffX > 0 ) {
            // swiped left
            if ( lightbox.currentImageIndex < lightbox.album.length - 1 ) {
                lightbox.changeImage( lightbox.currentImageIndex + 1 );
            } else {
                lightbox.changeImage( 0 );
            }
        } else {
            // swiped right
            if ( lightbox.currentImageIndex > 0 ) {
                lightbox.changeImage( lightbox.currentImageIndex - 1 );
            } else {
                lightbox.changeImage( lightbox.album.length - 1 );
            }
        }
    } else {
        // sliding vertically
        if ( diffY > 0 ) {
            // swiped up
            console.log( "swiped up" );
        } else {
            // swiped down
            console.log( "swiped down" );
        }
    }

    initialX = null;
    initialY = null;

    e.preventDefault();
}